import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#eye-slash_svg__a)">
      <path
        fill="#919196"
        d="M23.247.01a.75.75 0 0 1 .533 1.271l-22.5 22.5a.75.75 0 0 1-1.06-1.06l4.892-4.894a21.7 21.7 0 0 1-4.646-4.482 2.2 2.2 0 0 1-.008-2.695C2.04 8.58 6.334 3.751 12 3.751c1.975.05 3.902.596 5.602 1.586L22.72.22a.75.75 0 0 1 .527-.211M20.1 7.08a23 23 0 0 1 3.43 3.57 2.2 2.2 0 0 1 0 2.704C21.928 15.426 17.597 20.25 12 20.25a10.7 10.7 0 0 1-4.177-.893l3.015-3.015a4.486 4.486 0 0 0 5.513-3.175c.203-.764.2-1.568-.008-2.331zm-8.094.447a4.5 4.5 0 0 0-3.67 7.077L14.6 8.34a4.5 4.5 0 0 0-2.595-.812"
      />
    </g>
    <defs>
      <clipPath id="eye-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEyeSlash;
